<app-header></app-header>
<router-outlet></router-outlet>
<app-toaster></app-toaster>

<!-- Full-screen overlay shown during logout after password change -->
<div *ngIf="isLoggingOutAfterPasswordChange" class="logout-overlay">
  <div class="logout-overlay__content">
    <div class="logout-overlay__spinner"></div>
    <p class="logout-overlay__message">Password changed successfully. Logging out...</p>
  </div>
</div>